import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

// Modules
import user from './modules/user'
import event from './modules/event'
import loans from './modules/loans'
import formalities from './modules/formalities'
import endorsements from './modules/endorsements'
import cvc from './modules/cvc'
import payments from './modules/payments'
import vivemas from './modules/vivemas'
import requirements from './modules/requirements'
import utilities from './modules/utilities'
import popupciudad from './modules/popupciudad'
import nps from './modules/nps'

Vue.use(Vuex)

export default new Vuex.Store({
  /**
   * Assign the modules to the store
   */
  modules: {
    user,
    event,
    loans,
    formalities,
    endorsements,
    cvc,
    payments,
    requirements,
    vivemas,
    utilities,
    popupciudad,
    nps
  },
  plugins: [createPersistedState({
    key: 'jwt',
    paths: [
      'user.names',
      'user.info',
      'user.user',
      'user.initialValues',
      'user.exp',
      'user.session',
      'user.ip',
      'user.niubizSessionKey',
      'cvc.cvcParams',
      'payments.paymentsParams',
      'payments.subscribeParam',
      'user.functions'
    ]
  }), createPersistedState({
    key: 'vivemas',
    paths: [
      'vivemas.assists',
      'vivemas.benefits',
      'vivemas.assistCategories',
      'vivemas.benefitCategories',
      'vivemas.brands',
      'vivemas.cities'
    ]
  }), createPersistedState({
    key: 'nps',
    paths: [
      // 'nps.flagResponse'
    ]
  })]
})



// WEBPACK FOOTER //
// ./src/store/index.js